var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ItemList',{attrs:{"list-id":_vm.listId,"list-title":'Bids',"group-by":'sold_status'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }